import authRoutes from './auth'
import driveRoutes from './drive'

export default [...authRoutes, ...driveRoutes]
